module.exports = __webpack_public_path__ + "media/Q2.233250a5.mp4";